// removed by extract-text-webpack-plugin
module.exports = {"Mackerel":"#D2D6D9","White":"#FFFFFF","alertTitle":"G8186ef Gfbbf38","ineligibleIngredientsWrapper":"G2cbaef","ineligibleIngredientsInfoTip":"G4377fc"};